import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders, HttpParams} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from 'environments/environment';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { UserSessionService } from './user-session.service';
import { ApiService, URLS } from './api.service';
import { UserStorageService } from './user-storage.service';
import { Agente } from 'app/models/agente';
import { UnidadeFiltro } from 'app/models/UnidadeFiltro';
import { catchError, map } from 'rxjs/operators';
import { _throw as throwError } from 'rxjs/observable/throw';

declare var $: any;

@Injectable()
export class UnidadesPorUsuarioService {

    unidadesFiltro: UnidadeFiltro[];
    unidadesDoUsuario;
    idusuarioLogado;

    localStorageUnidade: any = [];

  constructor(private http: HttpClient, private userService: UserStorageService,private apiService: ApiService)
  {

  }

  private httpOptions = {headers: new HttpHeaders({'Content-Type': 'application/json'})};


  getUnidadesPorUsuario(idusuarioLogado:string): Observable<UnidadeFiltro[]> {

    let vm = this;
    let usuario = idusuarioLogado;

    return this.apiService.get(URLS.UNIDADES.GET_UNIDADES_LISTAR_POR_USUARIO,usuario, environment.urlLaravel)

    .pipe(
        map((data) => {

          let unidadesFiltradas: UnidadeFiltro[] = data.map((item) => ({
            id: item.id,
            sigla: item.sigla,
            checked: true,
          }));

          return unidadesFiltradas;
        }),
        catchError((error) => {
          return throwError(error);
        })
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/unidades-por-usuario.service.ts